<template>
  <div v-if="$store.state.menu.News">
    <v-container fill-height fluid grid-list-xl>
      <Loader :loading="loading" />
      <v-layout justify-center wrap>
        <v-flex md12>
          <material-card
            color="green"
            title="Объявления"
            text="Список всех объявлений"
          >
            <v-btn color="success" @click="openNews" text> Добавить </v-btn>
            <div class="mt-2">
              <v-text-field
                clearable="true"
                v-model="search"
                append-icon="mdi-magnify"
                label="Поиск..."
                class="sticky search"
                single-line
                hide-details
              ></v-text-field>
            </div>
            <v-data-table :headers="headers" :items="newsList" hide-actions>
              <template slot="headerCell" slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template slot="items" slot-scope="{ item }">
                <td
                  :class="`text-xs-left ${
                    item.is_active ? 'active' : 'no-active'
                  }`"
                >
                  {{ item.title }}
                </td>
                <td class="text-xs-left">{{ item.created_at | dateTime }}</td>
                <td class="text-xs-left">{{ item.updated_at | dateTime }}</td>
                <td class="text-xs-right min-width100">
                  <template>
                    <v-icon class="mr-3" @click="openNews(item.id)"
                      >mdi-pencil</v-icon
                    >
                    <v-icon
                      class="mr-2"
                      v-if="item.is_active"
                      @click="pushNews(item.id)"
                    >
                      mdi-bell-ring-outline
                    </v-icon>
                    <v-icon class="mr-2" v-else>mdi-bell-off-outline</v-icon>
                  </template>
                </td>
              </template>
            </v-data-table>

            <v-pagination
              v-if="last_page > 1"
              v-model="page"
              class="my-4"
              :length="last_page"
            ></v-pagination>
          </material-card>
        </v-flex>
      </v-layout>
      <Dealer />
    </v-container>
    <div class="small-dialog">
      <v-dialog width="600" v-if="currentNews" v-model="dialog">
        <v-card>
          <v-card-text>
            <v-text-field
              label="Заголовок"
              placeholder="Введите заголовок"
              v-model="title"
              outlined
            ></v-text-field>
            <v-textarea
              outlined
              placeholder="Введите описание"
              label="Полное описание"
              v-model="annotation"
            ></v-textarea>
            <v-checkbox
              v-model="is_active"
              label="Активен"
              type="checkbox"
            ></v-checkbox>
          </v-card-text>
          <v-divider> </v-divider>
          <v-card-actions class="text-xs-center">
            <v-btn color="success" text @click="setNews">Сохранить </v-btn>
            <v-btn color="primary" text @click="closeNews">Отмена </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Loader from "../components/helper/Loader";

export default {
  data: () => ({
    loading: true,
    dialog: false,
    newID: null,
    search: "",
    page: 1,
    last_page: 0,
    id: null,
    title: "",
    annotation: "",
    is_active: false,
    updated_at: "",

    currentNews: {
      id: null,
      title: "",
      annotation: "",
      is_active: false,
    },
    headers: [
      {
        sortable: false,
        text: "Заголовок",
        value: "phone_number",
      },
      {
        sortable: false,
        text: "Дата создания",
        value: "rate",
      },
      {
        sortable: false,
        text: "Дата редактирования",
        value: "title",
      },

      {
        sortable: false,
        text: "",
        value: "edit",
        align: "right",
      },
    ],
    newsList: [],
  }),
  methods: {
    getNews() {
      axios
        .get("admin/posts", {
          params: {
            per_page: 50,
            page: this.page,
            search: this.search,
          },
        })
        .then((response) => {
          this.newsList = response.data.data;
          this.last_page = response.data.last_page;
          this.loading = false;
        })
        .catch((error) => {});
    },
    setNews() {
      this.loading = true;
      axios
        .post("admin/posts/set", {
          title: this.title,
          id: this.id,
          annotation: this.annotation,
          is_active: this.is_active,
        })
        .then((response) => {
          this.currentNews.title = this.title;
          this.currentNews.id = response.data.id;
          this.currentNews.annotation = this.annotation;
          this.currentNews.is_active = this.is_active;
          this.currentNews.updated_at = response.data.updated_at;
          this.currentNews.created_at = response.data.created_at;
          if (response.data.is_new && this.page == 1) {
            this.newsList.unshift(this.currentNews);
          }
          this.$toast.success({
            title: "Объявление",
            message: "Вы добавили объявление",
          });

          this.closeNews();
        })
        .catch((error) => {
          let data = error.response.data;
          if (data.errors) {
            Object.keys(data.errors).forEach((item) => {
              let err = data.errors[item];
              for (let i = 0; i < err.length; i++) {
                this.$toast.error({
                  title: "Ошибка",
                  message: err[i],
                });
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openNews(newID) {
      if (newID) {
        this.dialog = true;
        this.newID = newID;
        let current = this.newsList.filter((x) => x.id == this.newID)[0];
        if (current) {
          this.currentNews = current;
          this.title = this.currentNews.title;
          this.annotation = this.currentNews.annotation;
          this.is_active = this.currentNews.is_active;
          this.id = this.currentNews.id;
        }
      }
    },
    closeNews() {
      this.id = null;
      this.title = "";
      this.annotation = "";
      this.is_active = false;
      this.updated_at = "";
      this.dialog = false;
      this.newID = null;
    },
    pushNews(postID) {
      this.loading = true;
      axios
        .get("admin/posts/push/" + postID)
        .then((response) => {
          if (response.data.success === false) {
            this.loading = false;
          } else {
            this.pushNews(postID);
          }
        })
        .catch((error) => {
          let data = error.response.data;
          if (data.errors) {
            Object.keys(data.errors).forEach((item) => {
              let err = data.errors[item];
              for (let i = 0; i < err.length; i++) {
                this.$toast.error({
                  title: "Ошибка",
                  message: err[i],
                });
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: { Loader },
  mounted() {
    this.getNews();
  },
  watch: {
    search() {
      this.page = 1;
      setTimeout(() => {
        this.getNews();
      }, 300);
    },
    page() {
      setTimeout(() => {
        this.getNews();
      }, 300);
    },
  },
};
</script>

<style>
.active {
  opacity: 1;
}

.no-active {
  opacity: 0.6;
}
</style>
